<div class="hangfire-page">
  <div class="subtitle">
    Scheduled background jobs for this Uniformax instance, with live state from Hangfire and curated narrative for each.
    Read-only — schedule changes are made in <code>Startup.cs</code>.
  </div>

  <div class="refresh-bar">
    <button class="p-button p-button-text" type="button" (click)="load()" [disabled]="isLoading">
      <i class="pi pi-refresh"></i>&nbsp;Refresh
    </button>
    <span *ngIf="isLoading"><i class="pi pi-spin pi-spinner"></i>&nbsp;Loading…</span>
  </div>

  <div *ngIf="errorMessage" class="error-state">
    <i class="pi pi-exclamation-triangle"></i>
    <div>{{ errorMessage }}</div>
  </div>

  <div *ngIf="!isLoading && !errorMessage && jobs.length === 0" class="loading-state">
    No Hangfire jobs registered.
  </div>

  <table class="jobs" *ngIf="!errorMessage && jobs.length > 0">
    <thead>
      <tr>
        <th aria-label="Expand row"></th>
        <th>Job</th>
        <th>Schedule</th>
        <th>Last Run</th>
        <th>Status</th>
        <th>Next Run</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let job of jobs; trackBy: trackByName">
        <tr>
          <td>
            <button class="expand-btn" type="button" (click)="toggle(job.Name)">
              <i class="pi" [class.pi-chevron-down]="isExpanded(job.Name)" [class.pi-chevron-right]="!isExpanded(job.Name)"></i>
            </button>
          </td>
          <td class="name-cell">
            {{ job.Name }}
            <div class="summary">{{ job.Summary }}</div>
          </td>
          <td class="schedule-cell">
            {{ job.Cadence }}
            <div class="cron">{{ job.Cron }}</div>
          </td>
          <td class="schedule-cell">
            <ng-container *ngIf="job.LastExecutionUtc; else dashCell1">{{ job.LastExecutionUtc | date:'medium' }}</ng-container>
            <ng-template #dashCell1>—</ng-template>
          </td>
          <td>
            <span class="state-pill" [ngClass]="statePillClass(job.LastState)">{{ stateDisplay(job) }}</span>
          </td>
          <td class="schedule-cell">
            <ng-container *ngIf="job.NextExecutionUtc; else dashCell2">{{ job.NextExecutionUtc | date:'medium' }}</ng-container>
            <ng-template #dashCell2>—</ng-template>
          </td>
        </tr>
        <tr *ngIf="isExpanded(job.Name)" class="detail-extras-row">
          <td colspan="6">
            <div class="extra-grid">
              <div class="extra-label">Why it matters</div>
              <div>{{ job.Why }}</div>

              <div class="extra-label">Touches</div>
              <div>{{ job.Touches }}</div>

              <div class="extra-label">Triggered by</div>
              <div>{{ job.TriggeredBy }}</div>

              <div class="extra-label">Failure mode</div>
              <div>{{ job.FailureMode }}</div>

              <div class="extra-label">Observability</div>
              <div>{{ job.Observability }}</div>

              <div class="extra-label">Registered at</div>
              <div class="code-loc">{{ job.CodeLocation }}</div>

              <div class="extra-label">Implementation</div>
              <div class="code-loc">{{ job.ImplementationLocation }}</div>

              <ng-container *ngIf="job.Notes">
                <div class="extra-label">Notes</div>
                <div>{{ job.Notes }}</div>
              </ng-container>

              <ng-container *ngIf="job.LastError">
                <div class="extra-label">Last error</div>
                <div class="error-block">{{ job.LastError }}</div>
              </ng-container>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
